// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { doc, getDoc } from "firebase/firestore";
// import { db } from "./firebase";
// import { motion } from "framer-motion";

// import Lightbox from "yet-another-react-lightbox";
// import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
// import "yet-another-react-lightbox/styles.css";
// import "yet-another-react-lightbox/plugins/thumbnails.css";

// export default function ProjectPage() {
//   const { id } = useParams();
//   const [project, setProject] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [lightboxOpen, setLightboxOpen] = useState(false);
//   const [lightboxIndex, setLightboxIndex] = useState(0);

//   useEffect(() => {
//     const fetchProject = async () => {
//       try {
//         const ref = doc(db, "projects", id);
//         const snap = await getDoc(ref);
//         if (snap.exists()) {
//           setProject(snap.data());
//         }
//       } catch (err) {
//         console.error("Error loading project:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [id]);

//   const imageSlides = project?.media
//     ?.filter((item) => item.type === "image")
//     .map((item) => ({ src: item.url })) || [];

//   if (loading) return <div className="p-6">Loading project...</div>;
//   if (!project) return <div className="p-6">Project not found.</div>;

//   return (
//     <motion.section
//       className="portfolio section"
//       id="project"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.4 }}
//     >
//       <div className="container">
//         <div className="row">
//           <div className="section-title padd-15">
//             <h2>{project.title}</h2>
//           </div>
//         </div>

//         <div className="row">
//           <div className="portfolio-heading padd-15">
//             <p className="text-gray-700">{project.description}</p>
//           </div>
//         </div>

//         <div className="row">
//           {project.media.map((item, index) => (
//             <div
//               key={index}
//               className="portfolio-item padd-15 filter-item project-card"
//               style={{ cursor: item.type === "image" ? "pointer" : "default" }}
//               onClick={() => {
//                 if (item.type === "image") {
//                   const imgIndex = imageSlides.findIndex((img) => img.src === item.url);
//                   setLightboxIndex(imgIndex);
//                   setLightboxOpen(true);
//                 }
//               }}
//             >
//               <div className="portfolio-item-inner">
//                 <div className="portfolio-img">
//                   {item.type === "image" ? (
//                     <img
//                       src={item.url}
//                       alt={`media-${index}`}
//                       style={{
//                         width: "100%",
//                         height: "200px",
//                         objectFit: "cover",
//                       }}
//                       loading="lazy"
//                     />
//                   ) : (
//                     <video
//                       src={item.url}
//                       muted
//                       controls
//                       style={{
//                         width: "100%",
//                         height: "200px",
//                         objectFit: "cover",
//                       }}
//                     />
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {lightboxOpen && (
//         <Lightbox
//           open={lightboxOpen}
//           close={() => setLightboxOpen(false)}
//           slides={imageSlides}
//           index={lightboxIndex}
//           plugins={[Thumbnails]}
//         />
//       )}
//     </motion.section>
//   );
// }

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { motion } from "framer-motion";

import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

export default function ProjectPage() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [tallVideos, setTallVideos] = useState({}); // track tall videos by index

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const ref = doc(db, "projects", id);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setProject(snap.data());
        }
      } catch (err) {
        console.error("Error loading project:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  const imageSlides =
    project?.media
      ?.filter((item) => item.type === "image")
      .map((item) => ({ src: item.url })) || [];

  const handleLoadedMetadata = (e, index) => {
    const video = e.target;
    const isTall = video.videoHeight > video.videoWidth;
    setTallVideos((prev) => ({ ...prev, [index]: isTall }));
  };

  if (loading) return <div className="p-6">Loading project...</div>;
  if (!project) return <div className="p-6">Project not found.</div>;

  return (
    <motion.section
      className="portfolio section"
      id="project"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>{project.title}</h2>
          </div>
        </div>

        <div className="row">
          <div className="portfolio-heading padd-15">
            <p className="text-gray-700">{project.description}</p>
          </div>
        </div>

        <div className="row">
          {project.media.map((item, index) => {
            const isTall = tallVideos[index];
            const cardStyle = isTall ? { height: "auto" } : { height: "200px" };
            const videoStyle = isTall
              ? { width: "100%", maxHeight: "500px", objectFit: "contain" }
              : { width: "100%", height: "200px", objectFit: "cover" };

            return (
              <div
                key={index}
                className="portfolio-item padd-15 filter-item project-card"
                style={cardStyle}
                onClick={() => {
                  if (item.type === "image") {
                    const imgIndex = imageSlides.findIndex(
                      (img) => img.src === item.url
                    );
                    setLightboxIndex(imgIndex);
                    setLightboxOpen(true);
                  }
                }}
              >
                <div className="portfolio-item-inner">
                  <div className="portfolio-img">
                    {item.type === "image" ? (
                      <img
                        src={item.url}
                        alt={`media-${index}`}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                        }}
                        loading="lazy"
                      />
                    ) : (
                      <video
                        src={item.url}
                        muted
                        controls
                        onLoadedMetadata={(e) => handleLoadedMetadata(e, index)}
                        className={isTall ? "tall-video" : ""}
                        style={{
                          width: "100%",
                          objectFit: isTall ? "contain" : "cover",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {lightboxOpen && (
        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          slides={imageSlides}
          index={lightboxIndex}
          plugins={[Thumbnails]}
        />
      )}
    </motion.section>
  );
}
